import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconThumbtack: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"thumbtack, pin, location, bookmark "} maskId="square-filled-radius-0-stroke-1-IconThumbtack"><path d="M7 2V6.10428C7 8.10754 6.1102 10.0073 4.57125 11.2898L4 11.7658V15H11.5V22H12.5V15H20V11.7658L19.4288 11.2898C17.8898 10.0073 17 8.10755 17 6.10428V2H7Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconThumbtack;
